import React, { useState, useEffect, useRef } from 'react';
import testimonialImage from '../../assets/images/user.png'
// import '../../pages/home/homePage.css';
import './responsive.css';
import './style.css';


interface Feedback {
    comment_by: string;
    designation: string;
    comments: string;
}

interface TestimonialsProps {
    feedbackList: Feedback[];
}

const testimonialData = [
    {
        comment_by: 'Sarah J.',
        designation: 'Posted 2 days ago', // Image import
        comments: 'The service was seamless. My old fridge was picked up the next day, and I received payment instantly. Highly recommend!'
    },
    {
        comment_by: 'Sarah K.',
        designation: 'Posted 2 days ago', // Image import
        comments: 'The service was seamless. My old fridge was picked up the next day, and I received payment instantly. Highly recommend!'
    },
    {
        comment_by: 'Sarah L.',
        designation: 'Posted 2 days ago', // Image import
        comments: 'The service was seamless. My old fridge was picked up the next day, and I received payment instantly. Highly recommend!'
    },
    {
        comment_by: 'Sarah M.',
        designation: 'Posted 2 days ago', // Image import
        comments: 'The service was seamless. My old fridge was picked up the next day, and I received payment instantly. Highly recommend!'
    },
    {
        comment_by: 'Sarah N.',
        designation: 'Posted 2 days ago', // Image import
        comments: 'The service was seamless. My old fridge was picked up the next day, and I received payment instantly. Highly recommend!'
    },
    {
        comment_by: 'Sarah O.',
        designation: 'Posted 2 days ago', // Image import
        comments: 'The service was seamless. My old fridge was picked up the next day, and I received payment instantly. Highly recommend!'
    },
    {
        comment_by: 'Sarah P.',
        designation: 'Posted 2 days ago', // Image import
        comments: 'The service was seamless. My old fridge was picked up the next day, and I received payment instantly. Highly recommend!'
    }
];

const Feedbacks = () => {
    const [feedbackList, setFeedbackList] = useState<any[]>([]);
    //   const [carouselItems, setCarouselItems] = useState(appliances);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;


    // const rotateFeedbackList = () => {
    //     setFeedbackList((prevList) => {
    //         // Remove the first item and append it to the end
    //         const rotatedList = [...prevList];
    //         const firstItem = rotatedList.shift();
    //         if (firstItem) {
    //             rotatedList.push(firstItem);
    //         }
    //         return rotatedList;
    //     });
    // };

    // const handleReadMoreClick = (index: number) => {
    //     setExpandedIndex(expandedIndex === index ? null : index);
    // };

    // useEffect(() => {
    //     const autoScroll = setInterval(() => {
    //         rotateFeedbackList(); // Rotate the feedback list every 10 seconds
    //     }, 3000);

    //     // Cleanup interval on unmount
    //     return () => clearInterval(autoScroll);
    // }, []);

    const fetchFeedbackList = async () => {
        try {
            const response = await fetch(`${backendUrl}${version}All-feedbacks`, 
              {  method: 'GET',
                headers:{
                  // Accept:'aplication/json',
                  "Content-Type": "application/json",
          
                },
                credentials: "include",
                mode:"cors"

                                          
              }
          );
            const data = await response.json();
            // //console.log("Fetched Data:", data); // Log the data to inspect its structure

            if (Array.isArray(data.data)) {
              const flattenedData = data.data.flat();
              // //console.log("flattenedData    -------------",flattenedData);
                setFeedbackList(flattenedData);
            } else {
                // console.warn('Expected data to be an array but received:', data);
                setFeedbackList([]); // Default to empty array if not an array
            }
        } catch (error) {
            //console.error('Error fetching feedback data:', error);
            setFeedbackList([]); // Default to empty array in case of error
        }
    };
    useEffect(() => {
        fetchFeedbackList();
    }, []);

    return (
      <section className="testimonials">
        <div className="container">
          <div className="ourPartner text-center">
            <h2 className="headingText">
            Trusted by Over 60,000 Satisfied Customer
            </h2>
          </div>
          {feedbackList.length > 0 && <div className="owl-carousel testi owl-theme">
            {feedbackList.map((feedback, index) => (
              <div className="item" key={index}>
                <div className="post_top_rating_wrap d-flex align-items-center justify-content-between">
                  <div className="post_img d-flex align-items-center">
                    <img
                      src={testimonialImage}
                      alt="Rating"
                    />
                    <div className="post_name_date ">
                      <p className="post_name">{feedback.comment_by}</p>
                      <p className="post_date"> {feedback.designation}</p>
                    </div>
                  </div>
                  <div className="rating_img">
                    <img src="/images/Rating_img.png" alt="Rating" />
                  </div>
                </div>
                <div className="bottom_txt">
                  <p>{feedback.comments}</p>
                </div>
              </div>
            ))}
          </div>
          }
        </div>
      </section>
    );
};

export default Feedbacks;
